
<div v-if="mixinEnvironnement_inEditor">
  <p v-if="content.idProduitCollection && produitCollection">
    Collection: {{ produitCollection.name }} ({{ produitCollection.titreCollectionFr }})
  </p>
  <p v-else>Liste unique de {{ content.listeIdProduit.length }} produit(s)</p>
</div>
